<template>
  <div class="">
    <mover class="my-7" :component="componentName" :component-type="componentObject.componentType"
           :component-slots="componentObject.slots" :folder="componentFolder"
           :component-name="componentFile">
      <template #components>
        {{ componentName }}
        <component class="w-100 disable-component-click" v-if="checkFolderException() && fileException.indexOf(componentFile) == -1" :is="componentName"/>
      </template>
    </mover>
  </div>
</template>

<script>
import Mover from "@/components/Mover";

export default {
  name: "ComponentViewerItem",
  components: {Mover},
  props: {
    componentObject: {},
    componentFile: {},
  },
  data() {
    return {
      folderException: [
        'RouterView',
        'Wrappers',
        'Authentication',
        'Product',
        'Category/Single',
        'Brand/Single',
        'ShoppingCart/Factors',
        'ShoppingCart/VerifyTransaction',
        'UpdateSiteMessage',
        'Loading',
        'Post/Single',
        'Page/Single',
        'Content/Single',
        'StepManager/Form/FormComponents',
      ],
      fileException: [
        'Section203',
        'Section5',
      ]
    }
  },
  computed: {
    componentPath() {
      return this.componentObject.path.replace('./', '')
    },
    componentFolder() {
      let folderPath = this.componentPath.split('/');
      folderPath.pop()
      return folderPath.join('/')
    },
    componentName() {
      return this.componentObject.name
    }
  },
  methods: {
    checkFolderException() {
      let checker = true

      this.folderException.forEach(item => {
        if (this.componentFolder.indexOf(item) > -1) {
          checker = false;
        }
      })
      return checker
    },
  },
}
</script>

<style scoped>
.disable-component-click {
  pointer-events: none;
}
</style>